export const getResizedImage = (
  initialData: Blob,
  width: number,
  height: number,
  type: string = 'image/webp',
  quality: number = 0.9,
): Promise<{
  scaledWidth: number;
  scaledHeight: number;
  resizedData: Blob;
  resizedPreview: string;
}> => {
  return new Promise((resolve, reject) => {    
    // Создаем URL для Blob
    const url = URL.createObjectURL(initialData);
    
    // Создаем изображение
    const image = new Image();
    image.src = url;
    image.onload = () => {
      try {
        const scaleFactor = Math.min(width / image.width, height / image.height);
        const scaledWidth = image.width * scaleFactor;
        const scaledHeight = image.height * scaleFactor;
        const canvas = document.createElement('canvas');
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(image, 0, 0, scaledWidth, scaledHeight);
        
        // Конвертируем обратно в ArrayBuffer
        canvas.toBlob(async (blob) => {
          if (!blob) {
            reject(new Error('Failed to resize image'));
            return;
          }
          
          const resizedData = blob;
          const resizedPreview = canvas.toDataURL(type);
          resolve({ scaledWidth, scaledHeight, resizedData, resizedPreview });
        }, type, quality);
      } catch (error) {
        reject(error);
      } finally {
        // Очищаем временный URL
        URL.revokeObjectURL(url);
      }
    };
    
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image for resizing'));
    };
  });
};